import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import formReducer from './createSlice';

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['uploadFileData', 'serviceId', 'categoryData', 'emailOTPData', 'subCategoryIds', 'projectID', 'materialReportData', 'costingReportData', 'materialReportStatusData', 'costingReportStatusData'],
};

const persistedReducer = persistReducer(persistConfig, formReducer);

const store = configureStore({
    reducer: {
        app: persistedReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
            },
        }),
});

const persistor = persistStore(store);

export { store, persistor };
